import { ENV } from './Env';
const AES_KEY = ENV.DECRYPTION_KEY;
const ENC_PREFIX = 'ENC:v1:';
export async function decrypt(value) {
 
  try {
    if (!AES_KEY) {
      throw new Error('AES key not found in environment variables');
    }
    if (typeof value !== 'string' || !value.trim()) {
      return null;
    }
 
    if (!value.startsWith(ENC_PREFIX)) {
      return value;
    }
 
    const encryptedBase64 = value.substring(ENC_PREFIX.length);
    const encryptedBytes = Uint8Array.from(
      atob(encryptedBase64),
      c => c.charCodeAt(0)
    );
 
    const iv = encryptedBytes.slice(0, 12);
    const cipherText = encryptedBytes.slice(12);
    const keyBytes = new TextEncoder().encode(AES_KEY);
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['decrypt']
    );
 
    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv,
        tagLength: 128,
      },
      cryptoKey,
      cipherText
 
    );
 
    return new TextDecoder().decode(decryptedBuffer);
 
  } catch (e) {
    // console.error('Decryption error:', e);
    return null;
  }
 
}
 